import React, { useReducer, useEffect } from "react";
import PropTypes from "prop-types";

import ConfigContext from "./ConfigContext";
import ConfigReducer from "./ConfigReducer";
import {
  CHANGE_FONT_SIZE,
  CHANGE_THEME,
  GET_THEMES,
  SELECT_THEME,
} from "./ConfigActions";
import { fetchTemas } from "../../services/parameter.service";

const ConfigProvider = ({ children }) => {
  const initialState = {
    theme: {
      darkGris: "#3b4e52",
      darkAzul: "#03323c",
      darkVerde: "#012b2b",
      azulVerde: "#05aaaa",
      grisPrimario: "#dfdedc",
      grisSecundario: "#f7f7f7",
      grisTipografia: "#808080",
      azulPpal: "#156dbc",
      blanco: "#fff",
      negro: "#000",
      error: "#ff7777",
    },
    themeSelected: "light",
    fontSizeMultiplier: 1.0,
    activeTheme: {},
    themes: [],
  };

  const [state, dispatch] = useReducer(ConfigReducer, initialState);
  const { theme, themes, activeTheme, themeSelected, fontSizeMultiplier } =
    state;

  const getTemas = async () => {
    try {
      const response = await fetchTemas();

      dispatch({ type: GET_THEMES, payload: response.data.list });
      selectTheme(response.data.list);
    } catch (error) {
      console.error(error);
    }
  };

  const selectTheme = (array) => {
    array.forEach((item) => {
      if (item.activo) {
        dispatch({ type: SELECT_THEME, payload: item });
      }
    });
  };

  const changeFontSize = (newSize) => {
    dispatch({ type: CHANGE_FONT_SIZE, payload: newSize });
  };

  const changeTheme = (newTheme) => {
    dispatch({ type: CHANGE_THEME, payload: newTheme });
  };

  useEffect(() => {
    getTemas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        theme,
        themes,
        activeTheme,
        themeSelected,
        fontSizeMultiplier,
        changeFontSize,
        changeTheme,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;

ConfigProvider.proppTypes = {
  children: PropTypes.element,
};
